import { render, staticRenderFns } from "./ReadMore.vue?vue&type=template&id=d0454436&scoped=true"
import script from "./ReadMore.vue?vue&type=script&lang=js"
export * from "./ReadMore.vue?vue&type=script&lang=js"
import style0 from "./ReadMore.vue?vue&type=style&index=0&id=d0454436&prod&lang=css"
import style1 from "./ReadMore.vue?vue&type=style&index=1&id=d0454436&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0454436",
  null
  
)

export default component.exports